import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import IconBox from '@/components/IconBox.vue';
import IconBoxContent from '@/components/IconBoxContent.vue';
import WhiteBox from '@/components/WhiteBox.vue';
import moment from 'moment';
import ReportCollection from '@/classes/ReportCollection';
//@ts-ignore
import ICountUp from 'vue-countup-v2';
//@ts-ignore
import PureVueChart from 'pure-vue-chart';
let MyData = class MyData extends Vue {
    generateNonWorkingRow(array) {
        let nonWorkingText = '';
        if (array.length === 1) {
            nonWorkingText +=
                "<div style='border: 1px solid #eee;padding:2px; margin:2px;'>" +
                    array[0].tariffName +
                    ' ' +
                    window.dateHandler.formatDateNoTime(array[0].date) +
                    '</div>';
        }
        else {
            nonWorkingText +=
                "<div style='border: 1px solid #eee;padding:2px; margin:2px;'>" +
                    array[0].tariffName +
                    ' (' +
                    window.dateHandler.formatDateNoTime(array[0].date) +
                    ' - ' +
                    window.dateHandler.formatDateNoTime(array[array.length - 1].date) +
                    ')</div>';
        }
        return nonWorkingText;
    }
    getMonthsLeftTolevelUp() {
        const hoursLeft = this.getCurrentLevelHoursLeft();
        if (hoursLeft > 0) {
            return Math.round(hoursLeft / this.calculateAverageToDate());
        }
        else {
            return 0;
        }
    }
    getCurrentLevelStartingHours() {
        const currentLevel = this.$data.employee.getLevelForDate();
        if (currentLevel !== null) {
            return currentLevel.hours;
        }
        else {
            return 0;
        }
    }
    getCurrentLevelStartingDate() {
        const currentLevel = this.$data.employee.getLevelForDate();
        if (currentLevel !== null) {
            return window.dateHandler.formatDateNoTime(currentLevel.from);
        }
        else {
            return 0;
        }
    }
    getCurrentLevelName() {
        const currentLevel = this.$data.employee.getLevelForDate();
        if (currentLevel === null) {
            return null;
        }
        return currentLevel.name;
    }
    getCurrentLevelHoursLeft() {
        const currentLevelForDate = this.$data.employee.getLevelForDate();
        const latestLevel = this.$data.employee.getCurrentLevel();
        if (currentLevelForDate !== latestLevel) {
            return 0;
        }
        else {
            return this.$data.employee.levelHoursLeft;
        }
    }
    calculateVacationTime() {
        const vacationTime = this.$data.reports
            .getVacationReportsMonth()
            .flat()
            .filter((report) => {
            return (report.tariffId === 'tariff-adc6fa25-84b7-4df9-9be8-9f9e8cfff0b6' &&
                report.from.split('T')[0] >= '2021-10-01'); // Semester tariff
        })
            .reduce((total, report) => {
            return total + report.hours;
        }, 0);
        return vacationTime;
    }
    calculateFutureVacationTime() {
        const today = moment();
        const vacationTime = this.$data.reports
            .getVacationReportsMonth()
            .flat()
            .filter((report) => {
            return (report.tariffId === 'tariff-adc6fa25-84b7-4df9-9be8-9f9e8cfff0b6' &&
                report.from.split('T')[0] >= '2021-10-01' &&
                window.dateHandler.isDateBefore(today, report.from)); // Semester tariff
        })
            .reduce((total, report) => {
            return total + report.hours;
        }, 0);
        return vacationTime;
    }
    calculateVariableSalary() {
        let amount = 0;
        const currentLevel = this.$data.employee.getLevelForDate();
        const billable = this.$data.reports.calculateMonthBillable();
        const vacationTime = this.calculateVacationTime();
        const stackHours = this.$data.reports.calculateMonthStack();
        const variableStartingHours = this.$data.variablePayStartingHours;
        if (currentLevel.fixedVariableSalary)
            return amount = currentLevel.fixedVariableSalary;
        if (billable > variableStartingHours - Math.min(vacationTime + stackHours, variableStartingHours) &&
            currentLevel !== null) {
            amount =
                currentLevel.payRate *
                    (billable -
                        (variableStartingHours - Math.min(vacationTime + stackHours, variableStartingHours)));
        }
        return amount;
    }
    dayHasReportedHours(date, excludeVacationDays = false) {
        const dateHandler = window.dateHandler;
        return !!this.$data.reports.reports.find((report) => {
            return (dateHandler.formatDateNoTime(report.date) === dateHandler.formatDateNoTime(date))
                && (!excludeVacationDays || report.tariffId !== 'tariff-adc6fa25-84b7-4df9-9be8-9f9e8cfff0b6');
        });
    }
    isNonWorkingDay(date) {
        const holidayColl = this.$store.getters.getHolidays;
        let holiday;
        if (holidayColl !== undefined && holidayColl !== null) {
            holiday = holidayColl.getHolidayForDate(date);
        }
        if (holiday !== undefined) {
            return true;
        }
        else if (moment(date).isoWeekday() === 6 || moment(date).isoWeekday() === 7) {
            return true;
        }
        else {
            return false;
        }
    }
    calculateAvailableHours() {
        const dateHandler = window.dateHandler;
        const today = moment();
        const currentMonthSelected = dateHandler.areDatesInSameMonth(this.$store.getters.getSelectedDate, today);
        // if you selected a previous month, no need to even calculate available hours
        if ((!currentMonthSelected &&
            dateHandler.isDateBefore(this.$store.getters.getSelectedDate, today)) ||
            moment(today).format('YYYY-MM-DD') === moment(today).endOf('month').format('YYYY-MM-DD')) {
            return 0;
        }
        const start = currentMonthSelected
            ? dateHandler.addDays(dateHandler, 1)
            : this.$store.getters.getSelectedDate;
        let totalHours = 0;
        for (let date = start; dateHandler.areDatesInSameMonth(date, start); date = dateHandler.addDays(date, 1)) {
            if (this.isNonWorkingDay(date) === false && this.dayHasReportedHours(date, true) === false) {
                totalHours += 8;
            }
        }
        const futureVacation = this.calculateFutureVacationTime();
        return Math.max(totalHours - futureVacation, 0);
    }
    calculateEstimatedVariableSalary() {
        let amount = 0;
        const currentLevel = this.$data.employee.getLevelForDate();
        const billable = this.$data.reports.calculateMonthBillable();
        const vacationTime = this.calculateVacationTime();
        const stackHours = this.$data.reports.calculateMonthStack();
        const availableHoursLeft = this.calculateAvailableHours();
        const variableStartingHours = this.$data.variablePayStartingHours;
        if (currentLevel !== null) {
            const calculatedAmount = currentLevel.payRate *
                (billable +
                    availableHoursLeft -
                    (variableStartingHours - Math.min(vacationTime + stackHours, variableStartingHours)));
            amount = Math.max(calculatedAmount, 0);
        }
        return amount;
    }
    isFixedSalary() {
        const currentLevel = this.$data.employee.getLevelForDate();
        console.log("currentLevel: ", currentLevel);
        if (currentLevel.fixedSalary)
            return true;
        else
            return false;
    }
    calculateFixedSalary() {
        let amount = 0;
        const currentLevel = this.$data.employee.getLevelForDate();
        if (currentLevel !== null) {
            amount = currentLevel.fixedPay || currentLevel.fixedSalary;
        }
        return amount;
    }
    shortDate(date) {
        return moment(date).format('YYYY-MM');
    }
    getWidthOfDiv(divId) {
        const divWidth = document.getElementById(divId);
        if (divWidth !== null) {
            return divWidth.offsetWidth;
        }
        else {
            return 0;
        }
    }
    loadYearReports() {
        const newStart = moment(this.$store.getters.getSelectedDate)
            .startOf('year')
            .subtract(1, 'months')
            .format('YYYY-MM-DD[T]00:00:00[Z]');
        const newEnd = moment(this.$store.getters.getSelectedDate)
            .endOf('year')
            .add(1, 'months')
            .format('YYYY-MM-DD[T]23:59:00[Z]');
        console.time('API-loadReportsYear');
        this.$store
            .dispatch('loadTimeReportsAsync', { start: newStart, end: newEnd })
            .then((response) => {
            if (response.status === 200) {
                console.timeEnd('API-loadReportsYear');
                const reportCollection = new ReportCollection();
                reportCollection.importReportObjectsFromJson(response.data);
                this.$data.reports = reportCollection; //this causes reloads
                this.createYearlyDataset();
                this.createTotalHoursWorked();
                this.$data.loading = false;
            }
        })
            .catch((err) => {
            this.errorHandler(err, 'loadTimeReportsAsync');
        });
    }
    createYearlyDataset() {
        const outputArray = [];
        for (let i = 11; i >= 0; i--) {
            const value = this.$data.reports.calculateMonthBillable(null, i) || 0;
            outputArray.push(value);
        }
        if (outputArray.reduce((a, b) => a + b, 0) === 0) {
            this.$data.yearlyDataset = null;
        }
        else {
            this.$data.yearlyDataset = outputArray.reverse();
        }
    }
    createTotalHoursWorked() {
        const hoursLeft = this.$data.employee.levelHoursLeft;
        const outputArray = [];
        let total = 0;
        for (let i = 0; i < 12; i++) {
            total = total + this.$data.reports.calculateMonthBillable(null, i);
            outputArray.push(total);
        }
        if (outputArray.reduce((a, b) => a + b, 0) === 0) {
            this.$data.totalHoursWorkedDataset = null;
        }
        else {
            this.$data.totalHoursWorkedDataset = outputArray;
        }
    }
    //returns the avarage hours for the month so far this year.
    calculateAverageToDate() {
        const numberOfMonths = moment(this.$store.getters.getSelectedDate).month();
        return this.$data.reports.getYearlyAverageForMonth(numberOfMonths);
    }
    getLastMonthBillable() {
        return this.$data.reports.calculateMonthBillable(1);
    }
    calculatePercentageChange() {
        let newColor = 'red';
        const previousMonth = this.$data.reports.calculateMonthBillable(1);
        const currentMonth = this.$data.reports.calculateMonthBillable();
        if (currentMonth > previousMonth) {
            newColor = 'green';
        }
        if (previousMonth !== 0 && currentMonth !== 0) {
            const newValue = (currentMonth / previousMonth) * 100 - 100;
            return { value: newValue, color: newColor };
        }
        return { value: 0, color: '' };
    }
    selectPreviousMonth() {
        const oldDate = this.$store.getters.getSelectedDate;
        const newDate = window.dateHandler
            .subtractMonths(this.$store.getters.getSelectedDate, 1)
            .startOf('month')
            .format('YYYY-MM-DD');
        this.$store.commit('setSelectedDate', { date: newDate });
        if (window.dateHandler.areDatesInSameYear(newDate, oldDate) === false) {
            this.$data.loading = true;
            this.loadYearReports();
        }
        this.getDateInfo();
    }
    selectNextMonth() {
        const oldDate = this.$store.getters.getSelectedDate;
        const newDate = window.dateHandler
            .addMonths(this.$store.getters.getSelectedDate, 1)
            .startOf('month')
            .format('YYYY-MM-DD');
        this.$store.commit('setSelectedDate', { date: newDate });
        if (window.dateHandler.areDatesInSameYear(newDate, oldDate) === false) {
            this.$data.loading = true;
            this.loadYearReports();
        }
        this.getDateInfo();
    }
    getDateInfo() {
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
    //generic error handler copied from store
    errorHandler(err, method) {
        if (err.response) {
            this.$store.dispatch('ToastMessage', {
                type: 'error',
                message: 'Error when invoking ' + method + ': ' + err,
            });
            console.log('Error when invoking ' + method + ': ' + err);
            console.log('Error response:');
            console.log(err.response.data);
        }
        if (err.request) {
            console.log('Error request:');
            console.log(err.request);
        }
        else {
            console.log('Error when invoking ' + method + ': ' + err);
            console.log('Error', err.message);
        }
        console.log('Error Config:');
        console.log(err.config);
    }
};
MyData = __decorate([
    Component({
        data() {
            return {
                loading: true,
                theme: this.$store.getters.getTheme,
                employee: null,
                salary: { variableCompensation: 0, fixedCompensation: 0 },
                singleMonth: null,
                dateInfo: {
                    year: 0,
                    month: null,
                    week: 0,
                    weekHours: 0,
                    monthHours: 0,
                },
                reports: null,
                yearlyDataset: null,
                totalHoursWorkedDataset: null,
                variablePayStartingHours: 120,
            };
        },
        created() {
            this.$data.employee = this.$store.getters.getLoggedInUser;
            this.$store.commit('setSelectedDate', { date: new Date() });
            this.loadYearReports();
            this.getDateInfo();
            this.$store
                .dispatch('validateEmployeeAsync')
                .then((response) => {
                const employeeReturn = response.data;
                this.$store.commit('setLoggedInUser', employeeReturn);
                this.$data.employee = this.$store.getters.getLoggedInUser;
            })
                .catch((error) => {
                console.log(error);
            });
        },
        computed: {
            vacationTime() {
                try {
                    return this.calculateVacationTime();
                }
                catch {
                    return 0;
                }
            },
            stackHours() {
                try {
                    return this.$data.reports.calculateMonthStack();
                }
                catch {
                    return 0;
                }
            },
        },
        components: {
            IconBox,
            IconBoxContent,
            WhiteBox,
            ICountUp,
            PureVueChart,
        },
    })
], MyData);
export default MyData;
